import React from 'react';
import createDimension, { useDimension } from 'dymension';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const Confirm = ({
  title,
  titleIcon,
  body,
  size,
  centered,
  className,
  backdrop,
  submit,
  cancel
}) => {
  const {
    show,
    resolve
  } = useDimension();

  const handleResolve = () => {
    resolve(true);
  };

  const handleReject = () => {
    resolve(false);
  };

  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    onHide: handleReject,
    size: size,
    className: className,
    centered: centered,
    backdrop: backdrop
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, null, titleIcon ? /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement("i", {
    className: titleIcon,
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement("div", {
    className: "ml-3"
  }, title)) : title)), /*#__PURE__*/React.createElement(Modal.Body, null, body), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: handleResolve
  }, submit), /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    onClick: handleReject
  }, cancel)));
};

Confirm.defaultProps = {
  backdrop: 'static',
  submit: "Yes",
  cancel: "No"
};
const ModalConfirm = createDimension(Confirm, {
  delay: 150
});
export default ModalConfirm;